export default __webpack_public_path__ + "static/media/contactless.f0be7f13.svg";